import React, { useState, useEffect } from 'react'
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core'
import { useCookies } from 'react-cookie'
import OidcSettings from './oidc/oidcsettings'
// import { makeAuthenticator, makeUserManager, Callback } from 'react-oidc'
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'
import App, { mainTheme } from './App'
import { UserContext } from './context/context'
import { blue } from '@material-ui/core/colors'
/* eslint-disable-next-line */
import jwt_decode from "jwt-decode";
import queryString from 'query-string'

// const userManager = makeUserManager(OidcSettings)
// userManager.signinRedirect({data: 'test'})

export const Authentication = (props) => {
  const [user, setUser] = useState({
    jwt: null,
    tid: null,
    travelerEmail: null,
    isTSCRequest: false,
    noAuth: false
  })
  const [cookies] = useCookies(['jwt', 'idToken', 'AuthorizationType'])

  useEffect(() => {
    const queryArray = window.location.hash.split('?')
    let path
    let queryTID
    if (queryArray.length > 0) {
      path = queryArray.shift()
      queryTID = queryString.parse(queryArray.join()).tid
    }

    let tid = ''
    let email = ''
    if (cookies.idToken || cookies.jwt || props.jwt) {
      const decoded = jwt_decode(cookies.idToken ?? cookies.jwt ?? props.jwt)
      if (decoded?.user !== null && decoded?.user !== undefined) {
        tid = decoded.user.userId
        email = decoded.user.emailAddress
      } else { // TSC or New Passport way
        tid = decoded.params.TravelerId
        email = decoded.preferred_username
      }
    }
    setUser({
      ocpkey: cookies.ocpkey,
      correlation: cookies.correlation,
      jwt: cookies.jwt ?? props.jwt,
      apiversion: cookies.jwt ?? cookies.idToken,
      tid: path === '#/evl' ? queryTID : tid,
      travelerEmail: email,
      isTSCRequest: (cookies.jwt === null || cookies.jwt === undefined) && (cookies.idToken === null || cookies.idToken === undefined),
      noAuth: path === '#/evl',
      authorizationType: cookies.AuthorizationType ?? ''
    })
  }, [
    cookies.jwt,
    cookies.correlation,
    cookies.apiversion,
    cookies.ocpkey,
    cookies.tid,
    props.jwt,
    cookies.idToken,
    cookies.AuthorizationType
  ])

  return (
    <UserContext.Provider value={{ user }}>
      <ThemeProvider theme={mainTheme}>
        <Router>
          <Switch>
            <Route
              exact
              path='/evl'
              render={(props) => {
                return <App {...props} isEvaluator />
              }}
            />
            <Route
              exact
              path='/cli'
              render={(props) => {
                return <App {...props} />
              }}
            />
            <div />
          </Switch>
        </Router>
      </ThemeProvider>
    </UserContext.Provider>
  )
}
